import React, { useEffect } from 'react';
import PageGraphic from '../components/PageGraphic';
import imgGrpahic from '../assets/img/services.png';
import { Wrapper } from './Landing';
import Quote from '../components/Quote';
import styled from 'styled-components/macro';

const H4 = styled.h4`
  display: inline-block;
  margin-bottom: 0;
`;
const Services = () => {
  useEffect(() => {
    document.title = 'Emprouen Advisors: Services';
  }, []);

  return (
    <Wrapper>
      <PageGraphic src={imgGrpahic} />
      <div>
        <h2>Services</h2>

        <Quote quoteStyle={{ maxWidth: '80%' }}>
          70% of transactions fail to perform and achieve their expected
          results. We transform acquisitions into productive companies.
        </Quote>

        <p>
          <H4>Transactions.</H4> Pre- or post-funding, we serve as our clients’
          eyes and ears for all operational issues in M&A deals – and often as
          their hands as well. Our services span the business transaction
          lifecycle from pre-acquisition through integration and ongoing
          operations. We put a strong emphasis on the practical, hands-on detail
          work that can help ensure a young company will mature into a stable
          and productive one.
        </p>

        <ul>
          <li>
            Operational due diligence to evaluate a target company’s leadership,
            facilities, inventory, processes and customers.
          </li>
          <li>
            Integration planning, from strategic analysis to detailed
            operational plans.
          </li>
        </ul>

        <p>
          <H4>Process Improvement.</H4> We bring a flexible suite of
          methodologies to bear on young companies when they can do the most
          good: at the inflection point of a transition.
        </p>

        <ul>
          <li>
            Operational efficiency to maximize resources, eliminate waste and
            reach financial targets.
          </li>
        </ul>

        <p>
          <H4>Turnarounds.</H4>
          Distressed or underperforming firms typically require the most work.
          We see beyond their high risk and attractive pricing, recognizing
          opportunities for a deeper intervention that touches every aspect of
          the business. The more involved we are in the day-to-day, the more our
          operational expertise helps create lasting value.
        </p>

        <ul>
          <li>
            Financial matters, including credit reviews, audit compliance, and
            covenant adherence.
          </li>
        </ul>

        <p>
          <H4>Teams.</H4> In our view, the human factors that drive success are
          overlooked just as often as the operational details. We believe
          strongly in the importance and power of organizational culture. Our
          core philosophy of servant-leadership helps us unlock the purpose,
          potential, and creativity of a company’s people. From the management
          team to the shop floor, we build the kind of culture that drives
          success.
        </p>

        <ul>
          <li>
            Interim leadership wherever it’s needed, including C-suite and board
            roles.
          </li>
        </ul>

        <p>
          <H4>Facilities, systems, and processes.</H4> Operational execution is
          where technical bridging and business-building most often struggles.
          It’s where we excel. When the deals are done and the path is mapped
          out, we roll up our sleeves. Our tested and refined, though not a
          canned approach, will always include structure, leadership roles &
          responsibilities, culture, process controls, metrics/KPIs and
          financial performance.
        </p>

        <ul>
          <li>
            Facility design and setup, from a bare floor to proof of concept or
            full production.
          </li>
          <li>
            Software selection and implementation, including ERP dashboards,
            general ledger solutions, and rollup of legacy systems.
          </li>
        </ul>
      </div>
    </Wrapper>
  );
};

export default Services;
